import { useEffect } from 'react';

import ManagePaymentsCard from '@/components/overview/ManagePaymentsCard';
import SetupDirectDebitCard from '@/components/overview/SetupDirectDebitCard';
import { useHasCurrentDirectDebitInstruction } from '@/hooks/billsAndPayments/useHasCurrentDirectDebitInstruction';

const DirectDebitActionCard = () => {
  const {
    isPending: isDirectDebitInstructionPending,
    isError: isDirectDebitInstructionError,
    data: hasDirectDebitInstruction,
    refetch: refetchDirectDebitInstruction,
    isRefetching: isRefetchingDirectDebitInstruction,
    isRefetchError: isRefetchingDirectDebitInstructionError,
  } = useHasCurrentDirectDebitInstruction();

  useEffect(() => {
    refetchDirectDebitInstruction();
  }, [refetchDirectDebitInstruction]);

  const isPending =
    isDirectDebitInstructionPending || isRefetchingDirectDebitInstruction;

  const isError =
    isDirectDebitInstructionError || isRefetchingDirectDebitInstructionError;

  if (hasDirectDebitInstruction) {
    return (
      <ManagePaymentsCard
        isLoading={isPending}
        isError={isError}
        DDInstructionType={hasDirectDebitInstruction?.node?.status}
      />
    );
  }

  return <SetupDirectDebitCard isLoading={isPending} isError={isError} />;
};

export default DirectDebitActionCard;
